/** Основа ключей localStorage меню; перед ней — `storageNamespace` приложения (`UiProvider`). */
export const SIDEBAR_STORAGE_KEY = 'srm.sidebar';
export const SIDEBAR_DEFAULT_WIDTH = 270;
export const SIDEBAR_MIN_WIDTH = 250;
export const SIDEBAR_MAX_WIDTH = 340;

export interface ISidebarStorageKeys {
    /** Ширина развёрнутого меню */
    width: string;
    /** Меню закреплено */
    pinned: string;
    /** Закреплённые пункты; `scope` — чьи (пользователь) */
    pins: (scope?: string | number) => string;
}

export const sidebarStorageKeys = (namespace: string, base = SIDEBAR_STORAGE_KEY): ISidebarStorageKeys => {
    const prefix = `${namespace}${base}`;
    return {
        width: `${prefix}.width`,
        pinned: `${prefix}.pinned`,
        pins: (scope) => (scope === undefined || scope === '' ? `${prefix}.pins` : `${prefix}.pins.${scope}`),
    };
};

export function clampSidebarWidth(width: number) {
    return Number.isFinite(width)
        ? Math.max(SIDEBAR_MIN_WIDTH, Math.min(SIDEBAR_MAX_WIDTH, Math.round(width)))
        : SIDEBAR_DEFAULT_WIDTH;
}

export function readSidebarWidth(key: string) {
    try {
        const stored = localStorage.getItem(key);
        const width = stored === null ? SIDEBAR_DEFAULT_WIDTH : Number(stored);
        return width >= SIDEBAR_MIN_WIDTH && width <= SIDEBAR_MAX_WIDTH
            ? clampSidebarWidth(width)
            : SIDEBAR_DEFAULT_WIDTH;
    } catch {
        return SIDEBAR_DEFAULT_WIDTH;
    }
}

export function readSidebarPinned(key: string) {
    try {
        return localStorage.getItem(key) !== 'false';
    } catch {
        return true;
    }
}

export function saveSidebarPreference(key: string, value: number | boolean) {
    try {
        localStorage.setItem(key, String(value));
    } catch {
        /* Приватный режим может запрещать storage. */
    }
}
